import { combineReducers } from "redux";
import profileReducer from "./profileSlice";
import authSlice from "./authSlice";
import themeSlice from "./themeSlice";
import languageSlice from "./languageSlice";
import profileDetailsReducer from "./profileDetailsSlice";

const rootReducer = combineReducers({
  profile: profileReducer,
  authProvider: authSlice,
  themeProvider: themeSlice,
  langProvider: languageSlice,
  profileDetails: profileDetailsReducer,
});

export default rootReducer;
